import React, { useState } from 'react';
import VisionSection from './VisionSection';
import WhatWeDoSection from './WhatWeDoSection';
import MissionSection from './MissionSection';
import CTASection from './CTASection';
import Footer from './Footer';

const AboutUs = ({ onNavigate }) => {
    const [activeFeature, setActiveFeature] = useState(0);

    return (
        <div className="min-h-screen bg-slate-900 text-white">
            {/* Background Elements - Only grid pattern and one subtle circle */}
            <div className="fixed inset-0 z-0 overflow-hidden">
                <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.015)_1px,transparent_1px),linear-gradient(to_right,rgba(255,255,255,0.015)_1px,transparent_1px)] bg-[size:64px_64px]" />
                {/* Single subtle background circle */}
                <div className="absolute top-1/3 left-1/2 w-96 h-96 bg-blue-500/3 rounded-full" />
            </div>

            {/* Main Sections */}
            <VisionSection onNavigate={onNavigate} />
            <WhatWeDoSection onNavigate={onNavigate} />
            <MissionSection />

            {/* Import existing CTA Section and Footer */}
            <CTASection onNavigate={onNavigate} />
            <Footer />
        </div>
    );
};

export default AboutUs;